var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordChangedSuccessfully(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2965",
    "data-name": "Group 2965",
    transform: "translate(-627 -285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    transform: "translate(627 285)",
    fill: "#fff",
    stroke: "#004f71",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 57,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 56,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "success-tick-svgrepo-com",
    transform: "translate(656.5 295.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2988",
    "data-name": "Group 2988",
    transform: "translate(0 21.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2987",
    "data-name": "Group 2987"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41136",
    "data-name": "Path 41136",
    d: "M48.124,46.542a2.292,2.292,0,0,0-2.292,2.292V67.167H4.583V25.917h41.25a2.292,2.292,0,0,0,4.583,0V23.626a2.292,2.292,0,0,0-2.292-2.292H2.292A2.292,2.292,0,0,0,0,23.626V69.458A2.292,2.292,0,0,0,2.292,71.75H48.124a2.292,2.292,0,0,0,2.292-2.292V48.834A2.292,2.292,0,0,0,48.124,46.542Z",
    transform: "translate(0 -21.334)",
    fill: "#004f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41137",
    "data-name": "Path 41137",
    d: "M168.575,86a2.292,2.292,0,0,0-3.241,0l-25.378,25.378-7.678-13.437a2.292,2.292,0,1,0-3.979,2.274l9.167,16.041a2.292,2.292,0,0,0,3.61.483l27.5-27.5A2.292,2.292,0,0,0,168.575,86Z",
    transform: "translate(-114.247 -78.459)",
    fill: "#004f71"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordChangedSuccessfully);
export default __webpack_public_path__ + "static/media/password-changed-successfully.c9e0f351.svg";
export { ForwardRef as ReactComponent };